var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',[_c('div',{staticClass:"scroll-container"},[_c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"text-xs-center mt-5 pt-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"60","width":"10","color":"primary"}}),_vm._t("default")],2)])],1)])]),_c('notification-snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }